<template>
  <el-form :inline="true" label-position="top">
    <el-form-item label="儲值帳戶" v-if="userType==='gaa'" >
      <el-select v-model="account" clearable filterable remote reserve-keyword placeholder="(搜尋儲值帳戶)"
        @change="onAccountSelected"
        :remote-method="fetchListOfBillingAccounts" :loading="select.accounts.loading">
        <el-option v-for="option in filteredAccounts" :key="option.id"
          :label="option.name" :value="option.id">
        </el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AccountFinder',
  components: [

  ],
  props: {
  },

  mounted() {
    this.fetchListOfBillingAccounts();
  },

  methods: {
    fetchListOfBillingAccounts(keyword) {
      const merchantId = 'ddcstore';
      if (keyword !== undefined && !keyword.length) return;
      this.select.accounts.loading = true;
      // let apiHost = 'https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/management/billing-accounts';
      let apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/billing-accounts`;
      apiHost += `?keyword=${keyword}&offset=0&limit=20`;
      // let apiHost = 'http://localhost:3000/vas/v1/merchants/ddcstore/management/billing-accounts';
      axios.get(
        `${apiHost}`
      )
      .then(response => {
        console.log(`[AccountFinder] fetchListOfBillingAccounts`, response.data);

        if (Array.isArray(response.data.accounts)) {
          this.accounts = [ ];
          response.data.accounts.forEach(account => {
            this.accounts.push({ id: account['id'], name: account['name'] });
          });
        }
        else {
          throw new Error(`Cannot resolve response data of account list.`);
        }
        
      })
      .catch(err => {
        console.error(`[AccountFinder] Cannot fetch account list`, err);
        // this.accounts.push({
        //   id: 1,
        //   name: 'test'
        // })
      })
      .finally(() => {
        this.select.accounts.loading = false;
      });
    },

    onAccountSelected(accountId) {
      console.log(`[AccountFinder] on account selected`, accountId);
      this.$emit('account-selected', accountId, this.selectedAccountName);
    }
  },

  data() {
    return {
      account: null,
      accounts: [ ],

      select: {
        accounts: {
          loading: false
        }
      }
    };
  },

  computed: {
    filteredAccounts() {
      return this.accounts;
      // return this.accounts.filter(account => {
      //   if (this.si)
      //     return shop.siId === this.si;
      //   return true;
      // });
    },
    selectedAccountName() {
      let ret = this.accounts.find(account => {
        return account.id === this.account;
      });
      if (ret) return ret.name;
      return null;
    },

    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    }
  }

}
</script>